import { render, staticRenderFns } from "./SideNavbar.vue?vue&type=template&id=641f35f8&scoped=true"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"
import style0 from "./SideNavbar.vue?vue&type=style&index=0&id=641f35f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f35f8",
  null
  
)

export default component.exports